import { setDailyRequestPending } from "../Diagramme"
import { fetchMultipleHeDataLogFilesRequestAction, PURPOSE_DAILY_VALUES } from "../HeDataLogs"
import Papa from "papaparse"
import { compressorIsMotorOn, compressorIsOnLoad, STATUS_NO_STATUS } from "../Kompressor";

/////////////////
// misc functions
/////////////////

const compareItems = (item1, item2) => {
	let diff = item1.year - item2.year
	if(diff === 0) {
		diff = item1.month - item2.month
		if(diff === 0) {
			diff = item1.day - item2.day
		}
	}
	return diff;
}

export const isHeDataLogItemInRange = (item, itemMin, itemMax) => {
	if(
		(compareItems(item, itemMin) >= 0) &&
		(compareItems(item, itemMax) <= 0)
	) {
		return true
	}
	else {
		return false
	}
}

export const generateHeDataLogItemFromDate = (aDate) => {
	return {
		year: aDate.getFullYear(),
		month: aDate.getMonth() + 1,
		day: aDate.getDate()
	}
}

const makeIndexListOfRequestedHeDataLogFiles = (sortedListOfHeDataLogFiles, timespan) => {
	const itemMin = generateHeDataLogItemFromDate(new Date(timespan.from_ms))
	const itemMax = generateHeDataLogItemFromDate(new Date(timespan.until_ms))
	const listOfIndexes = []
	sortedListOfHeDataLogFiles.forEach((item, index) => {
		if(isHeDataLogItemInRange(item, itemMin, itemMax))
		{
			listOfIndexes.push(index)
		}
	})
	return listOfIndexes
}

export const requestDailyStatisticsOfHeDataLogFiles = (type, timespan, sortedListOfHeDataLogFiles, dispatch) => {

	const listOfRequestedFiles = makeIndexListOfRequestedHeDataLogFiles(sortedListOfHeDataLogFiles, timespan)
	dispatch(setDailyRequestPending(type, true))
	dispatch(fetchMultipleHeDataLogFilesRequestAction(listOfRequestedFiles, PURPOSE_DAILY_VALUES))
}

export const requestEnergyBalanceOfHeDataLogFiles = (purpose, requiredData, sortedListOfHeDataLogFiles, dispatch) => {
	const listOfRequestedFiles = makeIndexListOfRequestedHeDataLogFiles(sortedListOfHeDataLogFiles, requiredData.range)
	dispatch(fetchMultipleHeDataLogFilesRequestAction(listOfRequestedFiles, purpose, requiredData))
}

export const calcXRangeOfAvailableDays = (sortedListofAvailableDays) => {

	const getTimeOfDay = (listElement, hour, min, sec, millis) => {
		// logs auf SD-Karte kennen keine Zeitzonen, deshalb alles so behandeln, als wäre es die gleiche Zeitzone wie der Browser
		let aDate = new Date()
		aDate.setFullYear(listElement.year)
		aDate.setMonth(listElement.month - 1)
		aDate.setDate(listElement.day)
		aDate.setHours(hour)
		aDate.setMinutes(min)
		aDate.setSeconds(sec)
		aDate.setMilliseconds(millis)
		const theTime = aDate.getTime()
		return theTime
	}

	if((sortedListofAvailableDays != null) && (sortedListofAvailableDays.length > 0)) {
		return [
			getTimeOfDay(sortedListofAvailableDays[0], 0, 0, 0, 0),
			getTimeOfDay(sortedListofAvailableDays[sortedListofAvailableDays.length - 1], 23, 59, 59, 999)
		]
	}
	return []
}

///////////////////////
// csv to internal data
///////////////////////

const nCompr = 10

// Software-Versionen vergleichen im Format "V1.23-RC4"
const checkSoftwareVersionMinimum = (minimalVersion, checkedVersion) => {

	const getMainSwVersion = (str) => {
		try {
			const withoutRc = (str.split('-'))[0] // strip "-rcX"
			const withoutV = withoutRc.split('V')[1]
			const numberAsString = withoutV.replace('.', '')
			const result = parseInt(numberAsString)
			if(isNaN(result)) {
				return -1
			}
			else {
				return result
			}
		}
		  catch {
			  return -2
		}
	}

	const getRcSwVersion = (str) => {
		try {
			const rcMarker = "-RC"
			if(!str.includes(rcMarker)) {
				return 0
			}
			const splitted = (str.split(rcMarker))[1]
			const result = parseInt(splitted)
			if(isNaN(result)) {
				return -1
			}
			else {
				return result
			}
		}
		catch {
			return -2
		}
	}

	const minVer = getMainSwVersion(minimalVersion)
	const chkVer = getMainSwVersion(checkedVersion)
	if((minVer < 0) || (chkVer < 0)) { // bei Fehlern nicht vergleichbar
		return false
	}
	else if(minVer < chkVer) { // checkedVersion groß genug
		return true
	}
	else if(minVer > chkVer) { // checkedVersion zu klein
		return false
	}
	else { // (chkVer === minVer) // Version gleich, also rc-Version vergleichen
		const minVerRc = getRcSwVersion(minimalVersion)
		const chkVerRc = getRcSwVersion(checkedVersion)
		if((minVerRc < 0) || (chkVerRc < 0)) { // bei Fehlern nicht vergleichbar
			return false
		}
		if((minVerRc === 0) && (chkVerRc === 0)) { // beide keine rc-version, also gleich
			return true
		}
		else if((minVerRc === 0) && (chkVerRc > 0)) { // minVerRc hat keine rc-version, chkVerRc schon, also checkedVersion zu klein
			return false
		}
		else if((minVerRc > 0) && (chkVerRc === 0)) { // minVerRc hat rc-version, chkVerRc dafür nicht, also checkedVersion groß genug
			return true
		}
		else if((minVerRc > 0) && (chkVerRc > 0)) { // beide haben rc-version, dann vergleichen
			if(chkVerRc >= minVerRc) { // checkedVersion groß genug
				return true
			}
			else {
				return false
			}
		}
		else { // falls ich noch was vergessen hab
			return false
		}
	}
}

const convertToNumber = (str, unit) => {

	const psiToBar = (psi) => (psi * 0.06894757)
	const mpaToBar = (mpa) => (mpa * 10)
	const ft3ToM3 = (ft3) => (ft3 * 35.31467)
	const degFToDegC = (degF) => (5/9 * (degF-32))
	const kelvinToDegC = (kelvin) => (kelvin - 273.15)

	const convertUnitToSi = (value, unit) => {
		if(
			(unit === "psi") ||
			(unit === "psi/s")
		) {
			return psiToBar(value)
		}
		else if(
			(unit === "MPa") ||
			(unit === "MPa/s")
		) {
			return mpaToBar(value)
		}
		else if(
			(unit === "ft³") ||
			(unit === "cfm")
		) {
			return ft3ToM3(value)
		}
		else if(unit === "°F") {
			return degFToDegC(value)
		}
		else if(unit === "K") {
			return kelvinToDegC(value)
		}
		else { // all other don't need conversion
			return value
		}
	}

	const value = parseFloat(str)
	if(isNaN(value)) {
		return NaN
	}
	return convertUnitToSi(value, unit)
}

const getUnitWithinSquareBrackets = (str) => (str.split('[')[1].split(']')[0])

const getDay = (data) => {
	const day = data[1][0]
	const dayArr = day.split('-')
	return {
		day: dayArr[0],
		month: dayArr[1],
		year: dayArr[2]
	}
}

const getTime = (item) => {
	const uhrArray = item[0].split(':')
	return {
		hour: uhrArray[0],
		minute: uhrArray[1],
		second: uhrArray[2]
	}
}

const getTimestamp = (aDay, aTime) => {
	// log-files kennen keine Zeitzonen, deshalb einfach als local-time annehmen
	let aDate = new Date()
	aDate.setFullYear(aDay.year)
	aDate.setMonth(aDay.month - 1)
	aDate.setDate(aDay.day)
	aDate.setHours(aTime.hour)
	aDate.setMinutes(aTime.minute)
	aDate.setSeconds(aTime.second)
	aDate.setMilliseconds(0)
	const ts = aDate.getTime()
	return ts
}

const transformPapaResultDataSinceV321rc10 = (data) => {

	const scanHeaderForUnits = (data) => {
		const headerLine = data[3]
		return {
			pressure: getUnitWithinSquareBrackets(headerLine[1]),
			pressureOverTime: getUnitWithinSquareBrackets(headerLine[7]),
			volume: getUnitWithinSquareBrackets(headerLine[8]),
			volumeOverTime: getUnitWithinSquareBrackets(headerLine[9]),
			power: getUnitWithinSquareBrackets(headerLine[17]),
			temperature: getUnitWithinSquareBrackets(headerLine[19])
		}
	}

	const convertToCompressor = (line, indexOffset, units) => {
		const statusText = line[indexOffset + 0]
		const statusArr = statusText.split(' ')
		const status = statusArr[0]
		return {
			status: convertToNumber(status, ""),
			auslastung: convertToNumber(line[indexOffset + 1], "%"),
			netzdruck: convertToNumber(line[indexOffset + 2], units.pressure),
			elLeistung: convertToNumber(line[indexOffset + 3], units.power),
			liefermenge: convertToNumber(line[indexOffset + 4], units.volumeOverTime),
			temperatur: convertToNumber(line[indexOffset + 5], units.temperature)
		}
	}

	const units = scanHeaderForUnits(data)
	const dataLines = data.filter((item, index) => ((index >= 4) && (item.length === 79)))
	const day = getDay(data)
	let transformedData = []
	dataLines.forEach((item) => {
		const time = getTime(item)
		let compressors = []
		const comprArrayOffset = 12
		const comprItemSize = 6
		for(let i = 0; i < nCompr; ++i) {
			compressors.push(convertToCompressor(item, comprArrayOffset + (i *  comprItemSize), units))
		}
		transformedData.push({
			timestamp: getTimestamp(day, time),
			netzdruck: convertToNumber(item[6], units.pressure),
			volumenstrom: convertToNumber(item[9], units.volumeOverTime),
			liefermenge: convertToNumber(item[10], units.volumeOverTime),
			compressors: compressors,
			auslastung: convertToNumber(item[77], "%")
		})
	})

	return transformedData
}

const transformPapaResultDataSinceV321rc5 = (data) => {

	const scanHeaderForUnits = (data) => {
		const headerLine = data[3]
		return {
			pressure: getUnitWithinSquareBrackets(headerLine[1]),
			pressureOverTime: getUnitWithinSquareBrackets(headerLine[7]),
			volume: getUnitWithinSquareBrackets(headerLine[8]),
			volumeOverTime: getUnitWithinSquareBrackets(headerLine[9]),
		}
	}

	const convertToCompressor = (line, indexOffset, units) => {
		return {
			status: NaN,
			auslastung: convertToNumber(line[indexOffset + 1], "%"),
			netzdruck: convertToNumber(line[indexOffset + 2], units.pressure),
			elLeistung: NaN,
			liefermenge: NaN,
			temperatur: NaN
		}
	}

	const units = scanHeaderForUnits(data)
	const dataLines = data.filter((item) => (item.length === 49))
	const day = getDay(data)
	let transformedData = []
	dataLines.forEach((item) => {
		const time = getTime(item)
		transformedData.push({
			timestamp: getTimestamp(day, time),
			netzdruck: convertToNumber(item[6], units.pressure),
			volumenstrom: convertToNumber(item[9], units.volumeOverTime),
			liefermenge: convertToNumber(item[10], units.volumeOverTime),
			compressors: [
				convertToCompressor(item, 12, units),
				convertToCompressor(item, 15, units),
				convertToCompressor(item, 18, units),
				convertToCompressor(item, 21, units),
				convertToCompressor(item, 24, units),
				convertToCompressor(item, 27, units),
				convertToCompressor(item, 30, units),
				convertToCompressor(item, 33, units),
				convertToCompressor(item, 36, units),
				convertToCompressor(item, 39, units),
			],
			auslastung: convertToNumber(item[47], "%")
		})
	})

	return transformedData
}

const transformPapaResultDataSinceV217rc3 = (data) => {

	const scanHeaderForUnits = (data) => {
		const headerLine = data[3]
		return {
			pressure: getUnitWithinSquareBrackets(headerLine[1]),
			pressureOverTime: getUnitWithinSquareBrackets(headerLine[7]),
			volume: getUnitWithinSquareBrackets(headerLine[8]),
			volumeOverTime: getUnitWithinSquareBrackets(headerLine[9]),
		}
	}

	const createDummyCompressorData = () => {
		return {
			status: NaN,
			auslastung: NaN,
			netzdruck: NaN,
			elLeistung: NaN,
			liefermenge: NaN,
			temperatur: NaN
		}
	}

	const units = scanHeaderForUnits(data)
	const dataLines = data.filter((item) => (item.length === 27))
	const day = getDay(data)
	let transformedData = []
	let compressors = []
	for(let i = 0; i < nCompr; ++i) {
		compressors.push(createDummyCompressorData())
	}
	dataLines.forEach((item) => {
		const time = getTime(item)
		transformedData.push({
			timestamp: getTimestamp(day, time),
			netzdruck: convertToNumber(item[6], units.pressure),
			volumenstrom: convertToNumber(item[9], units.volumeOverTime),
			liefermenge: convertToNumber(item[10], units.volumeOverTime),
			compressors: compressors,
			auslastung: NaN
		})
	})

	return transformedData
}

const transformPapaResultDataSinceV215rc1 = (data) => {

	const scanHeaderForUnits = (data) => {
		const headerLine = data[3]
		return {
			pressure: getUnitWithinSquareBrackets(headerLine[1]),
			pressureOverTime: getUnitWithinSquareBrackets(headerLine[7]),
			volume: getUnitWithinSquareBrackets(headerLine[8]),
			volumeOverTime: getUnitWithinSquareBrackets(headerLine[9]),
		}
	}

	const createDummyCompressorData = () => {
		return {
			status: NaN,
			auslastung: NaN,
			netzdruck: NaN,
			elLeistung: NaN,
			liefermenge: NaN,
			temperatur: NaN
		}
	}

	const units = scanHeaderForUnits(data)
	const dataLines = data.filter((item) => (item.length === 23))
	const day = getDay(data)
	let transformedData = []
	let compressors = []
	for(let i = 0; i < nCompr; ++i) {
		compressors.push(createDummyCompressorData())
	}
	dataLines.forEach((item) => {
		const time = getTime(item)
		transformedData.push({
			timestamp: getTimestamp(day, time),
			netzdruck: convertToNumber(item[6], units.pressure),
			volumenstrom: convertToNumber(item[9], units.volumeOverTime),
			liefermenge: convertToNumber(item[10], units.volumeOverTime),
			compressors: compressors,
			auslastung: NaN
		})
	})

	return transformedData
}

const transfromPapaResultData = (data, softwareVersionString) => {

	if(checkSoftwareVersionMinimum("V3.21-RC10", softwareVersionString)) {
		return transformPapaResultDataSinceV321rc10(data)
	}
	else if(checkSoftwareVersionMinimum("V3.21-RC5", softwareVersionString)) {
		return transformPapaResultDataSinceV321rc5(data)
	}
	else if(checkSoftwareVersionMinimum("V2.17-RC3", softwareVersionString)) {
		return transformPapaResultDataSinceV217rc3(data)
	}
	else if(checkSoftwareVersionMinimum("V2.15-RC1", softwareVersionString)) {
		transformPapaResultDataSinceV215rc1(data)
	}
	else {
		return [] // alles was vorher war, wird es selten geben ...und irgendwann ists auch gut ^^
	}
}

const findFirstHeaderIndex = papaResultData => {
	const nLinesHeader = 3
	for(let i = 0; i < papaResultData.length - nLinesHeader; ++i) {
		if(
			(papaResultData[i + 0].length === 3) &&
			(papaResultData[i + 1].length === 3) &&
			(papaResultData[i + 2].length === 1)
		){
			return i
		}
	}
	return null // wenn kein header gefunden
}

export const parseHeDataLogFile = (csvData) => {
	const papaResult = Papa.parse(csvData) // papaparse ist der hammer :-)
	console.log("papaResult: ", papaResult)

	// keine errors akzeptieren
	if(papaResult.errors.length !== 0) {
		return null
	}

	// find first header
	const firstHeaderIndex = findFirstHeaderIndex(papaResult.data)
	if(firstHeaderIndex === null) {
		return null
	}

	const fileHeader = {
		date: papaResult.data[firstHeaderIndex + 1][0],
		schematicNum: papaResult.data[firstHeaderIndex + 1][1],
		softwareVerseion: papaResult.data[firstHeaderIndex + 1][2]
	}

	const papaResultDataFiltered = papaResult.data.filter((item, index) => (index >= firstHeaderIndex))
	console.log("papaResultDataFiltered: ", papaResultDataFiltered)

	const transformedData = transfromPapaResultData(papaResultDataFiltered, fileHeader.softwareVerseion)

	const fileData = {
		header: fileHeader,
		data: transformedData
	}

	console.log("fileData: ", fileData)
	return fileData
}

//////////////////////////
// internal-data to charts
//////////////////////////

const sampleTimeDiff = 2 // Sekunden

export const getDataPoints = (xrange, sortedListOfAvailableDays) => {

	const getAllDataPointsInRange = (xrange, sortedListOfAvailableDays) => {
		let allDataPointsInRange = []
		sortedListOfAvailableDays.forEach(day => {
			if(day.file) {
				if(day.file.data) {
					day.file.data.forEach(dataPoint => {
						if((dataPoint.timestamp >= xrange[0]) && dataPoint.timestamp <= xrange[1]) {
							allDataPointsInRange.push(dataPoint)
						}
					})
				}
			}
		})
		return allDataPointsInRange
	}

	const fitToMaxDataPoints = (allDataPointsInRange) => {
		const maxDataPoints = 655 // arbiträre Zahl; kopiert von "Datenlog.js"
		let dataPoints
		if(allDataPointsInRange <= maxDataPoints) {
			dataPoints = allDataPointsInRange
		}
		else {
			const nJumpDataPoints = allDataPointsInRange.length / maxDataPoints
			let dataPointIndexCounter = 0
			dataPoints = []
			allDataPointsInRange.forEach((item, index) => {
				if(index === Math.round(dataPointIndexCounter)) {
					dataPoints.push(item)
					dataPointIndexCounter += nJumpDataPoints
				}
			})
		}
		return dataPoints
	}

	const allDataPointsInRange = getAllDataPointsInRange(xrange, sortedListOfAvailableDays)
	const dataPoints = fitToMaxDataPoints(allDataPointsInRange)
	return dataPoints
}

export const createLogValues = (dataPoints) => {

	const createLogValueCompressor = (cindex, compr) => {
		let netzdruck = 0
		let liefermenge = 0
		let elLeistung = 0
		let temperatur = 0
		if(compr.status !== STATUS_NO_STATUS) { // Kein Status nur, wenn Kompressor der GLW nicht bekannt
			netzdruck = compr.netzdruck
			liefermenge = compr.liefermenge
			elLeistung = compr.elLeistung
			temperatur = compr.temperatur
		}
		return {
			cindex: cindex,
			status: compr.status,
			technology: 0, // wird bei den charts nicht genutzt
			line_pressure_bar: netzdruck,
			delivery_volume_m3min: liefermenge,
			electrical_power_kW: elLeistung,
			temperature_degC: temperatur
		}
	}

	const createLogValue = (dataPoint) => {
		let compressors = []
		let gesamtLeistung_kW = 0
		dataPoint.compressors.forEach((compr, index) => {
			if(compr.status !== STATUS_NO_STATUS) { // Kein Status nur, wenn Kompressor der GLW nicht bekannt
				gesamtLeistung_kW += compr.elLeistung
			}
			compressors.push(createLogValueCompressor(index, compr))
		})

		return {
			date: dataPoint.timestamp,
			ablauf: {
				master: {
					system_pressure_bar: dataPoint.netzdruck,
					load_factor_percent: dataPoint.auslastung / 100, // erwartet Wert zwischen 0..1
					volume_flow_m3min: dataPoint.volumenstrom,
					delivery_volume_m3min: dataPoint.liefermenge,
					energy_consumption_kW: gesamtLeistung_kW
				},
				compressors: compressors
			}
		}
	}

	// convert to correct data-format
	let logValues = []
	dataPoints.forEach(dataPoint => {
		logValues.push(createLogValue(dataPoint))
	})

	return logValues
}

export const createStateChanges = (dataPoints) => {

	let compressorsLastChange = []
	let compressorUsed = []
	for(let i = 0; i < nCompr; ++i) {
		compressorsLastChange.push({
			cindex: i,
			state: NaN,
			start: NaN,
			end: NaN
		})
		compressorUsed.push(false)
	}

	let changes = []
	dataPoints.forEach((dataPoint, index) => {
		const timestamp = dataPoint.timestamp
		dataPoint.compressors.forEach((compr, cindex) => {
			// init mit status/timestamp
			if(isNaN(compressorsLastChange[cindex].state) || isNaN(compressorsLastChange[cindex].start)) {
				if(compr.status !== STATUS_NO_STATUS) {
					compressorUsed[cindex] = true
				}
				compressorsLastChange[cindex].state = compr.status
				compressorsLastChange[cindex].start = timestamp
			}
			// für alle weiteren
			else {
				if(compressorsLastChange[cindex].state !== compr.status) {
					compressorsLastChange[cindex].end = timestamp
					changes.push({...compressorsLastChange[cindex]})
					compressorUsed[cindex] = true
					compressorsLastChange[cindex].state = compr.status
					compressorsLastChange[cindex].start = timestamp
				}
				else { // wenn sich status nicht geändert hat
					// normalerweise hier nichts tun;
					// außer beim letzten dataPoint: den letzten change abschließen
					if(index === (dataPoints.length - 1) && (compressorUsed[cindex] === true)) {
						compressorsLastChange[cindex].end = timestamp
						changes.push({...compressorsLastChange[cindex]})
					}
				}
			}
		})
	})

	let usedCompressorsCount = 0
	compressorUsed.forEach(item => {
		if(item === true) {
			usedCompressorsCount++
		}
	})
	if(usedCompressorsCount === 0) { // sonst kommt es zu Fehlermeldungen beim Victory-Chart rendern
		usedCompressorsCount = 1
		changes = [] // nur zur Sicherheit, sollte eigentlich automatisch so sein
	}

	return {
		num_compressors: usedCompressorsCount,
		changes: changes
	}
}

export const calcLastLeerlauf = (requestedDays) => {

	let compressorUsed = []
	for(let i = 0; i < nCompr; ++i) {
		compressorUsed.push(false)
	}

	const sumLastLeerlauf = (comprIndex) => {

		let timeLastlauf_s = 0
		let timeLeerlauf_s = 0
		requestedDays.forEach(dayItem => {
			if(dayItem.file) {
				let counterLastlauf = 0
				let counterLeerlauf = 0
				dayItem.file.data.forEach(line => {
					let motorOn = compressorIsMotorOn(line.compressors[comprIndex])
					let loadOn = compressorIsOnLoad(line.compressors[comprIndex])
					if(
						(!isNaN(line.compressors[comprIndex].status)) &&
						(line.compressors[comprIndex].status !== STATUS_NO_STATUS)
					) {
						compressorUsed[comprIndex] = true
					}
					if(motorOn && loadOn) {
						counterLastlauf++
					}
					if(motorOn && !loadOn) {
						counterLeerlauf++
					}
				})
				timeLastlauf_s += (counterLastlauf * sampleTimeDiff)
				timeLeerlauf_s += (counterLeerlauf * sampleTimeDiff)
			}
		})

		return {
			lastlauf_s: timeLastlauf_s,
			leerlauf_s: timeLeerlauf_s
		}
	}

	let lastLeerlaufArray = []
	for(let comprIndex = 0; comprIndex < nCompr; ++comprIndex) {
		const lastLeerlaufData = sumLastLeerlauf(comprIndex)
		if(compressorUsed[comprIndex] === true) {
			lastLeerlaufArray.push({
				cindex: comprIndex,
				lastlauf_s: lastLeerlaufData.lastlauf_s,
				leerlauf_s: lastLeerlaufData.leerlauf_s,
			})
		}
	}
	return lastLeerlaufArray
}

export const calcEntlastungen = (requestedDays) => {

	let compressorUsed = []
	for(let i = 0; i < nCompr; ++i) {
		compressorUsed.push(false)
	}

	const countEntlastungenCompressor = (comprIndex) => {
		let counter = 0
		let lastState = 0
		let thisState = 0
		requestedDays.forEach(dayItem => {
			if(dayItem.file) {
				// set init state
				if(dayItem.file.data.length > 0) {
					if(dayItem.file.data[0].compressors.length > 0) {
						lastState = compressorIsOnLoad(dayItem.file.data[0].compressors[comprIndex])
					}
				}
				// add up entlastungen
				dayItem.file.data.forEach(line => {
					if(line.compressors[comprIndex].status !== STATUS_NO_STATUS) {
						compressorUsed[comprIndex] = true
					}
					thisState = compressorIsOnLoad(line.compressors[comprIndex])
					if(!lastState && thisState) {
						counter++
					}
					lastState = thisState
				})
			}
		})
		return counter
	}

	let entlastungenArray = []
	for(let comprIndex = 0; comprIndex < nCompr; ++comprIndex) {
		const entlastungen = countEntlastungenCompressor(comprIndex)
		if(compressorUsed[comprIndex] === true) {
			entlastungenArray.push({
				cindex: comprIndex,
				entlastungen: entlastungen
			})
		}
	}
	return entlastungenArray
}

export const calcMotorstarts = (requestedDays) => {

	let compressorUsed = []
	for(let i = 0; i < nCompr; ++i) {
		compressorUsed.push(false)
	}

	const countMotorstartsCompressor = (comprIndex) => {
		let startCounter = 0
		let lastState = 0
		let thisState = 0
		requestedDays.forEach(dayItem => {
			if(dayItem.file) {
				// set init state
				if(dayItem.file.data.length > 0) {
					if(dayItem.file.data[0].compressors.length > 0) {
						lastState = compressorIsMotorOn(dayItem.file.data[0].compressors[comprIndex])
					}
				}
				// add up motorstarts
				dayItem.file.data.forEach(line => {
					if(
						(!isNaN(line.compressors[comprIndex].status)) &&
						(line.compressors[comprIndex].status !== STATUS_NO_STATUS)
					) {
						compressorUsed[comprIndex] = true
					}
					thisState = compressorIsMotorOn(line.compressors[comprIndex])
					if(!lastState && thisState) {
						startCounter++
					}
					lastState = thisState
				})
			}
		})
		return startCounter
	}

	let motorstartsArray = []
	for(let comprIndex = 0; comprIndex < nCompr; ++comprIndex) {
		const motorstarts = countMotorstartsCompressor(comprIndex)
		if(compressorUsed[comprIndex] === true) {
			motorstartsArray.push({
				cindex: comprIndex,
				motorstarts: motorstarts
			})
		}
	}
	return motorstartsArray
}

export const calcEnergiverbrauch = (requestedDays) => {

	let compressorUsed = []
	for(let i = 0; i < nCompr; ++i) {
		compressorUsed.push(false)
	}

	const integrateComprLeistung = (comprIndex) => {
		let energieverbrauchGesamt_kWs = 0 // in kW * Sekunden
		let energieverbrauchLastlauf_kWs = 0 // in kW * Sekunden
		requestedDays.forEach(dayItem => {
			if(dayItem.file) {
				let leistungGesamtSum = 0
				let leistungLastlaufSum = 0
				dayItem.file.data.forEach(line => {
					if(line.compressors[comprIndex].status !== STATUS_NO_STATUS) {
						compressorUsed[comprIndex] = true
						let motorOn = compressorIsMotorOn(line.compressors[comprIndex])
						let loadOn = compressorIsOnLoad(line.compressors[comprIndex])
						let leistung = line.compressors[comprIndex].elLeistung
						if(motorOn && loadOn) {
							leistungLastlaufSum += leistung
						}
						leistungGesamtSum += leistung
					}
				})
				energieverbrauchGesamt_kWs += (leistungGesamtSum * sampleTimeDiff)
				energieverbrauchLastlauf_kWs += (leistungLastlaufSum * sampleTimeDiff)
			}
		})

		return {
			cindex: comprIndex,
			gesamtenergie_kWh: energieverbrauchGesamt_kWs / 60 / 60,
			lastenergie_kWh:  energieverbrauchLastlauf_kWs / 60 / 60,
		}
	}

	const sumPlantEnergieverbrauch = (energieverbrauchComprArray) => {
		let gesamtenergie_kWh = 0
		let lastenergie_kWh = 0
		energieverbrauchComprArray.forEach((item, cindex) => {
			if(compressorUsed[cindex] === true) {
				gesamtenergie_kWh += item.gesamtenergie_kWh
				lastenergie_kWh += item.lastenergie_kWh
			}
		})
		return {
			cindex: -1,
			gesamtenergie_kWh: gesamtenergie_kWh,
			lastenergie_kWh: lastenergie_kWh,
		}
	}

	// Berechne Energieverbrauch der einzelnen Kompressoren
	let energieverbrauchComprArray = []
	for(let comprIndex = 0; comprIndex < nCompr; ++comprIndex) {
		energieverbrauchComprArray.push(integrateComprLeistung(comprIndex))
	}

	// Berechne Energieverbrauch der gesamten Station
	const energieVerbrauchPlant = sumPlantEnergieverbrauch(energieverbrauchComprArray)
	if(isNaN(energieVerbrauchPlant)) {
		return []
	}

	// Energieverbrauch Station und Kompressoren in ein Array packen
	let energieverbrauchArray = []
	energieverbrauchArray.push(energieVerbrauchPlant)
	energieverbrauchComprArray.forEach((item, cindex) => {
		if(compressorUsed[cindex] === true) {
			energieverbrauchArray.push(item)
		}
	})
	return energieverbrauchArray
}

export const calcGeliefertesVolumen = (requestedDays) => {

	let compressorUsed = []
	for(let i = 0; i < nCompr; ++i) {
		compressorUsed.push(false)
	}

	const integrateComprLiefermenge = (comprIndex) => {
		let geliefertesVolumen_m3 = 0
		requestedDays.forEach(dayItem => {
			if(dayItem.file) {
				let liefermengeSum = 0
				dayItem.file.data.forEach(line => {
					if(line.compressors[comprIndex].status !== STATUS_NO_STATUS) {
						compressorUsed[comprIndex] = true
						liefermengeSum += line.compressors[comprIndex].liefermenge
					}
				})
				liefermengeSum /= 60 // von m³/min zu m³/s
				geliefertesVolumen_m3 += liefermengeSum * sampleTimeDiff
			}
		})

		return {
			cindex: comprIndex,
			geliefertesVolumen_m3: geliefertesVolumen_m3,
		}
	}

	const sumPlantGeliefertesVolumen = (geliefertesVolumenComprArr) => {
		let geliefertesVolumen_m3 = 0
		geliefertesVolumenComprArr.forEach((item, cindex) => {
			if(compressorUsed[cindex] === true) {
				geliefertesVolumen_m3 += item.geliefertesVolumen_m3
			}
		})
		return {
			cindex: -1,
			geliefertesVolumen_m3: geliefertesVolumen_m3,
		}
	}

	// berechne geliefertes Volumen der einzelnen Kompressoren
	let geliefertesVolumenComprArray = []
	for(let comprIndex = 0; comprIndex < nCompr; ++comprIndex) {
		geliefertesVolumenComprArray.push(integrateComprLiefermenge(comprIndex))
	}

	// berechne geliefertes Volumen der gesamten Station
	const geliefertesVolumenPlant = sumPlantGeliefertesVolumen(geliefertesVolumenComprArray)

	// geliefertesVolumen Station und Kompressoren in ein Array packen
	let geliefertesVolumenArray = []
	geliefertesVolumenArray.push(geliefertesVolumenPlant)
	geliefertesVolumenComprArray.forEach((item, cindex) => {
		if(compressorUsed[cindex] === true) {
			geliefertesVolumenArray.push(item)
		}
	})
	return geliefertesVolumenArray
}

export const calcSpezifischeLeistungsaufnahme = (energieverbrauchData, geliefertesVolumenData) => {
	let dataArr = []
	if(
		(energieverbrauchData.length > 0) &&
		(energieverbrauchData.length === geliefertesVolumenData.length)
	) {
		for(let comprIndex = 0; comprIndex < energieverbrauchData.length; ++comprIndex) {
			if(energieverbrauchData[comprIndex].cindex === geliefertesVolumenData[comprIndex].cindex) {
				let gesamtenergie_kWh = energieverbrauchData[comprIndex].gesamtenergie_kWh
				let lastenergie_kWh = energieverbrauchData[comprIndex].lastenergie_kWh
				let geliefertesVolumen = geliefertesVolumenData[comprIndex].geliefertesVolumen_m3
				let gesamtspezifische_leistung_kWhm3 = 0
				let spezifische_leistung_kWhm3 = 0
				if(geliefertesVolumen > 0) {
					gesamtspezifische_leistung_kWhm3 = gesamtenergie_kWh / geliefertesVolumen
					spezifische_leistung_kWhm3 = lastenergie_kWh / geliefertesVolumen
				}
				dataArr.push({
					cindex: energieverbrauchData[comprIndex].cindex,
					gesamtspezifische_leistung_kWhm3: gesamtspezifische_leistung_kWhm3 * 60, // kWh/m³ -> kWmin/m³ bzw. kW/(m³/min); member-name ist jetzt zwar falsch, aber ich muss das bisherige Verhalten übernehmen
					spezifische_leistung_kWhm3: spezifische_leistung_kWhm3 * 60, // kWh/m³ -> kWmin/m³ bzw. kW/(m³/min); member-name ist jetzt zwar falsch, aber ich muss das bisherige Verhalten übernehmen
				})
			}
			else {
				return []
			}
		}
	}
	return dataArr
}

const getMinMaxValues = (requestedDays) => {

	let compressorUsed = []
	for(let i = 0; i < nCompr; ++i) {
		compressorUsed.push(false)
	}

	const getMinMaxValuesCompressor = (comprIndex) => {
		let leistungMin
		let leistungMax
		let liefermengeMin
		let liefermengeMax
		requestedDays.forEach(dayItem => {
			if(dayItem.file) {
				// set init state
				if(dayItem.file.data.length > 0) {
					if(dayItem.file.data[0].compressors.length > 0) {
						//lastState = compressorIsOnLoad(dayItem.file.data[0].compressors[comprIndex])
						leistungMin = dayItem.file.data[0].compressors[comprIndex].elLeistung
						leistungMax = leistungMin
						liefermengeMin = dayItem.file.data[0].compressors[comprIndex].liefermenge
						liefermengeMax = liefermengeMin
					}
				}
				// add up entlastungen
				dayItem.file.data.forEach(line => {
					if(line.compressors[comprIndex].status !== STATUS_NO_STATUS) {
						compressorUsed[comprIndex] = true
					}
					const leistung = line.compressors[comprIndex].elLeistung
					const liefermenge = line.compressors[comprIndex].liefermenge
					if(leistung > leistungMax) {
						leistungMax = leistung
					}
					if(leistung < leistungMin) {
						leistungMin = leistung
					}
					if(liefermenge > liefermengeMax) {
						liefermengeMax = liefermenge
					}
					if(liefermenge < liefermengeMin) {
						liefermengeMin = liefermenge
					}
				})
			}
		})
		return {
			cindex: comprIndex,
			leistungMin_kW: leistungMin, // kW -> kW
			leistungMax_kW: leistungMax, // kW -> kW
			liefermengeMin_m3h: liefermengeMin * 60, // m³/min -> m³/h
			liefermengeMax_m3h: liefermengeMax * 60  // m³/min -> m³/h
		}
	}

	const getMinMaxValuesPlant = () => {
		let netzdruckMin
		let netzdruckMax
		requestedDays.forEach(dayItem => {
			if(dayItem.file) {
				// set init state
				if(dayItem.file.data.length > 0) {
					netzdruckMin = dayItem.file.data[0].netzdruck
					netzdruckMax = netzdruckMin
				}
				// add up entlastungen
				dayItem.file.data.forEach(line => {
					const netzdruck = line.netzdruck
					if(netzdruck > netzdruckMax) {
						netzdruckMax = netzdruck
					}
					if(netzdruck < netzdruckMin) {
						netzdruckMin = netzdruck
					}
				})
			}
		})
		return {
			netzdruckMin_bar: netzdruckMin, // bar -> bar
			netzdruckMax_bar: netzdruckMax // bar -> bar
		}
	}

	let minMaxComprArray = []
	for(let comprIndex = 0; comprIndex < nCompr; ++comprIndex) {
		minMaxComprArray.push(getMinMaxValuesCompressor(comprIndex))
	}

	let minMaxValuesCompr = []
	minMaxComprArray.forEach((item, cindex) => {
		if(compressorUsed[cindex] === true) {
			minMaxValuesCompr.push(item)
		}
	})
	return {
		plant: getMinMaxValuesPlant(),
		compressors: minMaxValuesCompr
	}
}

export const createEnergyBalanceRawData = (requiredData, requestedDays) => {

	const entlastungen = calcEntlastungen(requestedDays)
	const motorstarts = calcMotorstarts(requestedDays)
	const energieverbrauch = calcEnergiverbrauch(requestedDays)
	const lastLeerlaufZeiten = calcLastLeerlauf(requestedDays)
	const geliefertesVolumen = calcGeliefertesVolumen(requestedDays)
	const minMaxValues = getMinMaxValues(requestedDays)

	console.log("geliefertesVolumen: ", geliefertesVolumen)

	let compressors = []
	for(let i = 0; i < nCompr; ++i) {
		const comprEntlastungen = entlastungen.filter(item => (item.cindex === i))
		const comprMotorstarts = motorstarts.filter(item => (item.cindex === i))
		const comprEnergieverbrauch = energieverbrauch.filter(item => (item.cindex === i))
		const comprMinMaxValues = minMaxValues.compressors.filter(item => (item.cindex === i))
		const comprGeliefertesVolumen = geliefertesVolumen.filter(item => (item.cindex === i))
		const comprLastLeerlaufZeiten = lastLeerlaufZeiten.filter(item => (item.cindex === i))
		let compr = {
			anzahl_entlastungen: (comprEntlastungen.length === 1) ? comprEntlastungen[0].entlastungen : 0,
			anzahl_motor_starts: (comprMotorstarts.length === 1) ? comprMotorstarts[0].motorstarts : 0,
			cindex: i,
			energie_lastlauf_1kWh0: (comprEnergieverbrauch.length === 1) ? comprEnergieverbrauch[0].lastenergie_kWh : 0,
			energie_leerlauf_1kWh0: (comprEnergieverbrauch.length === 1) ? (comprEnergieverbrauch[0].gesamtenergie_kWh - comprEnergieverbrauch[0].lastenergie_kWh) : 0,
			leistung_max_1kW0: (comprMinMaxValues.length === 1) ? comprMinMaxValues[0].leistungMax_kW : -1e+30,
			leistung_min_1kW0: (comprMinMaxValues.length === 1) ? comprMinMaxValues[0].leistungMin_kW : 1e+30,
			liefermenge_max_1m3h0: (comprMinMaxValues.length === 1) ? comprMinMaxValues[0].liefermengeMax_m3h : -1e+30,
			liefermenge_min_1m3h0: (comprMinMaxValues.length === 1) ? comprMinMaxValues[0].liefermengeMin_m3h : 1e+30,
			volumen_liefermenge_1m30: (comprGeliefertesVolumen.length === 1) ? comprGeliefertesVolumen[0].geliefertesVolumen_m3 : 0,
			zeit_lastlauf_1s0: (comprLastLeerlaufZeiten.length === 1) ? comprLastLeerlaufZeiten[0].lastlauf_s : 0,
			zeit_leerlauf_1s0: (comprLastLeerlaufZeiten.length === 1) ? comprLastLeerlaufZeiten[0].leerlauf_s : 0,
		}
		compressors.push(compr)
	}

	let rawBalanceData = {
		compressors: compressors,
		plant: [
			{
				netzdruck_max_1bar0: minMaxValues.plant.netzdruckMax_bar,
				netzdruck_min_1bar0: minMaxValues.plant.netzdruckMin_bar
			}
		],
		range: {
			from_ms: requiredData.range.from_ms,
			until_ms: requiredData.range.until_ms
		}
	}

	console.log("rawBalanceData: ", rawBalanceData)

	return rawBalanceData
}